import React, { useState } from 'react'
import AppHeader from './Components/AppHeader'
import CountryList from './Components/CountryList'
import './scss/App.scss'

const App = () => {
  const [filter, setFilter] = useState('world')
  const [searchString, setSearchString] = useState('')
  const [dataLocal, setdataLocal] = useState('')

  return (
    <div className='App'>
      <AppHeader
        filter={filter}
        setFilter={setFilter}
        searchString={searchString}
        setSearchString={setSearchString}
        dataLocal={dataLocal}
        setdataLocal={setdataLocal}
      />
      <CountryList
        filter={filter}
        searchString={searchString}
        dataLocal={dataLocal}
      />
    </div>
  )
}

export default App
